import { render, staticRenderFns } from "./Sheet.vue?vue&type=template&id=6cf6cf8f&scoped=true"
import script from "./Sheet.vue?vue&type=script&lang=js"
export * from "./Sheet.vue?vue&type=script&lang=js"
import style0 from "./Sheet.vue?vue&type=style&index=0&id=6cf6cf8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf6cf8f",
  null
  
)

export default component.exports